import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Separator from 'flarum/common/components/Separator';
import Link from 'flarum/common/components/Link';
import tagLabel from 'ext:flarum/tags/common/helpers/tagLabel';
export default class MyTags extends Component {
  view() {
    const tags = app.store.all('tags').filter(tag => tag.subscription() === 'follow' || tag.subscription() === 'lurk');
    const showPlaceholder = app.forum.attribute('my-tags.enable-placeholder');
    if (!tags.length && !showPlaceholder) return null;
    return m('[', null, m("div", {
      className: "MyTags",
      role: "group"
    }, m("p", {
      className: "MyTags__label"
    }, app.translator.trans('acpl-my-tags.forum.index.my_tags')), !tags.length && showPlaceholder ? m("span", null, app.translator.trans('acpl-my-tags.forum.index.placeholder', {
      a: m(Link, {
        href: app.route('tags')
      })
    })) : m("ul", {
      className: "MyTags__list"
    }, tags.map(tag => m("li", {
      key: `myTags-tag-${tag.id()}`
    }, tagLabel(tag, {
      link: app.route.tag(tag)
    }))))), m(Separator, null));
  }
}
flarum.reg.add('acpl-my-tags', 'forum/components/MyTags', MyTags);